import { ColumnShape } from '@/components/Table/types';

import MicroSkillAction from './components/MicroSkillAction';
import MicroSkillCell from './components/MicroSkillCell';
import MicroSkillSelect from './components/MicroSkillSelect';
import { MicroSkillTableDatumType } from './types';

export type Params = {};

export const getMicroSkillsNameColumn = (): ColumnShape<MicroSkillTableDatumType> => {
  return {
    key: 'name',
    flexGrow: 1,
    width: 374,
    headerRenderer: () => null,
    cellRenderer: ({ rowData }) => <MicroSkillCell rowData={rowData} />,
  };
};

export const getMicroSkillsActionsColumn = (): ColumnShape<MicroSkillTableDatumType> => {
  return {
    key: 'action',
    width: 72,
    frozen: 'right',
    headerRenderer: () => null,
    cellRenderer: ({ rowData }) => <MicroSkillAction rowData={rowData} />,
  };
};

export const getMicroSkillsSelectColumn = (): ColumnShape<MicroSkillTableDatumType> => {
  return {
    key: 'select',
    width: 40,
    frozen: 'right',
    headerRenderer: () => null,
    cellRenderer: ({ rowData }) => <MicroSkillSelect rowData={rowData} />,
  };
};
